import {CONSTANTS} from "../components/config/constants";
import {Users} from "../components/user/users";
import {CandidatesTable} from "../components/user/candidates";

const Candidates = () => {
    return <CandidatesTable no_users={'No Candidates'} user_type={CONSTANTS.USER_TYPES.CANDIDATE}
                  page_title={'Candidates'}/>
}
export default Candidates;
